import './Footer.scss';
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowTopIcon } from './../../ui/Icons/ArrowTopIcon';
import { FacebookIcon } from './../../ui/Icons/FacebookIcon';
import { InstagramIcon } from './../../ui/Icons/InstagramIcon';
// import { LinkedinIcon } from './../../ui/Icons/LinkedinIcon';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0 });
  };

  const currentYear = new Date().getFullYear();

  return (
    <div className="footer row">
      <div className="footer__top col">
        <div className="wrapper">
          <div className='row'>
            <div className="footer__col col">
              <Link className="caption link-primary" to="/privacy">
                Política de Privacidade
              </Link>
            </div>
            <div className="footer__col col">
              <p className="caption">Siga-nos nas redes sociais</p>
              <a
                href="https://www.facebook.com/PloverDigitalSolutions/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__top-icon link-primary"
                aria-label="Seguir a Plover no Facebook, abre num novo separador"
              >
                <FacebookIcon />
              </a>
              <a
                href="https://www.instagram.com/plover.digital.solutions/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__top-icon link-primary"
                aria-label="Seguir a Plover no Instagram, abre num novo separador"
              >
                <InstagramIcon />
              </a>
              {/* 
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="footer__top-icon"
                aria-label="Seguir a Plover no LinkedIn, abre num novo separador"
              >
                <LinkedinIcon />
              </a> 
              */}
            </div>
          </div>
        </div>
      </div>

      <div className="footer__bottom col">
        <div className="wrapper">
          <div className='row'>
            <span className="footnote footer__col col">
              © {currentYear} Plover. Todos os direitos reservados
            </span>
            <button onClick={scrollToTop} className="col footer__col footer__top-btn link-primary" aria-label="Voltar ao início">
              <span>Topo</span>
              <ArrowTopIcon />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;